import { Text } from "@marketplace/ui";
import { cva } from "class-variance-authority";

export type PayoutStatusPillStatus =
  | "succeeded"
  | "accepted"
  | "failed"
  | "requested";

type PayoutStatusPillProps = {
  status: PayoutStatusPillStatus;
  customLabel?: string;
};

const statusPill = cva(
  "flex justify-center items-center w-[148px] h-6 rounded",
  {
    variants: {
      status: {
        succeeded: "bg-[#E5FFDE] text-[#45B527]",
        accepted: "bg-[#FEFFDE] text-[#929618]",
        failed: "bg-[#FFE7E7] text-[#8B1515]",
        requested: "bg-[#F3F4F6] text-[#6B7280]"
      }
    }
  }
);

const STATUS_LABELS: Record<PayoutStatusPillStatus, string> = {
  succeeded: "Succeeded",
  accepted: "Accepted",
  failed: "Failed",
  requested: "Requested"
};

export const PayoutStatusPill = ({
  status,
  customLabel
}: PayoutStatusPillProps) => {
  return (
    <div className={statusPill({ status })}>
      <Text>{customLabel || STATUS_LABELS[status]}</Text>
    </div>
  );
};
